import React from 'react'
import { Card, Col, Row, Typography, Divider } from 'antd'
import { default as SEO } from './Seo'
import { default as HeaderHero } from './HeaderHero'
import { getDomain } from '../utils'

import ContactStyle from '../../styles/Contact.module.css'

const tabletImage = 'hero/contact/Contact_1024x300-no-copy.jpg'
const desktopImage = 'hero/contact/Contact_1440x300-no-copy.jpg'
const largeScreenImage = 'hero/contact/Contact_1620x300-no-copy.jpg'
const xtraLargeScreenImage = 'hero/contact/Contact_1960x300-no-copy.jpg'
const smallImage = 'hero/contact/Contact_375x188.jpg'
const smallImage390 = 'hero/contact/Contact_390x188.jpg'
const mobileImage = 'hero/contact/Contact_428x188.jpg'
const mobileImage768 = 'hero/contact/Contact_768x300-no-copy.jpg'

const { Link, Text } = Typography

const Contact = () => {
  const redirectChat = () => {
    const chatDomain = getDomain('chat')
    window.location.href = `https://${chatDomain}`
  }
  return (
    <>
      <SEO
        description="Please contact CURE Auto Insurance for policy questions, claims support, or general inquiries. View our call center hours and contact us to report a claim."
        title="Contact Us | CURE Auto Insurance for NJ, PA & MI Drivers"
        url="/contact"
      />
      <HeaderHero
        desktopImage={desktopImage}
        largeScreenImage={largeScreenImage}
        mobileImage={mobileImage}
        mobileImage768={mobileImage768}
        smallImage={smallImage}
        smallImage390={smallImage390}
        tabletImage={tabletImage}
        title="CONTACT"
        xtraLargeScreenImage={xtraLargeScreenImage}
        alt={"Contact us - CURE auto insurance"}
      />
      <Row className={`${ContactStyle["contact-container"]} page-text-margin`}>
        <Row className={`${ContactStyle["margin-bottom-12"]} ${ContactStyle["mobile-margin-bottom-0"]}`}>
          <Text className={`${ContactStyle["sub-text"]} ${ContactStyle["mobile-sub-text"]}`}>When support is needed, our team is here and happy to help.</Text>
        </Row>
        <Col span={24}>
          <Row>
            <Col lg={{ span: 8 }} md={8} xl={7}>
              <Card bordered={false} className={`${ContactStyle["customer-relations-card"]} ${ContactStyle["mobile-padding-0"]}`}>
                <Row className={`${ContactStyle["text-reset"]}`}>
                  <Col className={`${ContactStyle["desktop"]}`} span={24}>
                    <Text className={`${ContactStyle["contact-sub-title"]}`}>Customer Center</Text>
                  </Col>
                  <Col className={`${ContactStyle["mobile"]} ${ContactStyle["mobile-margin-0"]}`} span={24}>
                    <Text className={`${ContactStyle["contact-sub-title"]}`}>Customer Relations Center</Text>
                  </Col>
                  <Col className={`${ContactStyle["margin-top-6"]} ${ContactStyle["margin-bottom-6"]}`} span={24}>
                    <div>
                      <a onClick={() => redirectChat()} className={`${ContactStyle["online-fnol"]}`}>
                        Live Chat
                      </a>
                    </div>
                  </Col>
                  <Col className={`${ContactStyle["margin-bottom-8"]} ${ContactStyle["margin-left-68"]} ${ContactStyle["desktop"]}`} span={24}>
                    <Text className={`${ContactStyle["contact-sub-title"]}`} />
                  </Col>
                  <Col
                    className={`${ContactStyle["margin-bottom-12"]} ${ContactStyle["mobile-12"]}`}
                    lg={{ span: 24 }}
                    md={{ span: 0 }}
                    sm={{ span: 0 }}
                    xl={{ span: 24 }}
                    xs={{ span: 0 }}
                  >
                    <Text>800-535-CURE (2873)</Text>
                  </Col>
                  <Col
                    className={`${ContactStyle["margin-bottom-12"]} ${ContactStyle["mobile-12"]} ${ContactStyle["margin-top-8"]}`}
                    lg={{ span: 0 }}
                    md={{ span: 24 }}
                    sm={{ span: 24 }}
                    xl={{ span: 0 }}
                    xs={{ span: 24 }}
                  >
                    <Link className={`${ContactStyle["mobile-text"]}`} href="tel:+1800535CURE">
                      800-535-CURE (2873)
                    </Link>
                  </Col>
                  <Row className={`${ContactStyle["text-reset"]}`}>
                    <Col className={`${ContactStyle["margin-bottom-8"]} ${ContactStyle["desktop"]}`} span={24}>
                      <Text className={`${ContactStyle["contact-sub-title"]}`}>Hours</Text>
                    </Col>
                  </Row>
                  <Col className={`${ContactStyle["margin-bottom-8"]} ${ContactStyle["mobile"]}`} span={24}>
                    <Text className={`${ContactStyle["contact-sub-title"]}`}>Hours</Text>
                  </Col>
                  <Col className={`${ContactStyle["margin-bottom-12"]} ${ContactStyle["mobile-12"]} ${ContactStyle["mobile-sub-text"]}`} span={24}>
                    <ul>
                      <li>Monday-Friday: 8:00am - 7:00pm</li>
                      <li>Saturday: 9:30am - 4:00pm</li>
                    </ul>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Divider className={`${ContactStyle["mobile"]}`} />
            <Col lg={{ span: 8 }} md={8} xl={7}>
              <Card bordered={false} className={`${ContactStyle["customer-relations-card"]}`}>
                <Row className={`${ContactStyle["text-reset"]}`}>
                  <Col className={`${ContactStyle["margin-bottom-8"]} ${ContactStyle["above-button"]}`} span={24}>
                    <Text className={`${ContactStyle["contact-sub-title"]}`}>Report Claim</Text>
                  </Col>
                  <Col className={`${ContactStyle["margin-top-6"]} ${ContactStyle["margin-bottom-6"]}`} span={24}>
                    <div>
                      <a href="/claims/fnol-form" className={`${ContactStyle["online-fnol"]}`}>
                        ONLINE 24/7
                      </a>
                    </div>
                  </Col>
                  <Col className={`${ContactStyle["margin-bottom-8"]} ${ContactStyle["margin-left-68"]} ${ContactStyle["desktop"]} ${ContactStyle["below-button"]}`} span={24}>
                    <Text className={`${ContactStyle["contact-sub-title"]}`} />
                  </Col>
                  <Col
                    className={`${ContactStyle["margin-bottom-12"]} ${ContactStyle["mobile-12"]}`}
                    lg={{ span: 24 }}
                    md={{ span: 0 }}
                    sm={{ span: 0 }}
                    xl={{ span: 24 }}
                    xs={{ span: 0 }}
                  >
                    <Text>800-229-9151</Text>
                  </Col>
                  <Col
                    className={`${ContactStyle["margin-bottom-12"]} ${ContactStyle["margin-top-4"]}`}
                    lg={{ span: 0 }}
                    md={{ span: 24 }}
                    sm={{ span: 24 }}
                    xl={{ span: 0 }}
                    xs={{ span: 24 }}
                  >
                    <Link className={`${ContactStyle["mobile-text"]}`} href="tel:+18002299151">
                      800-229-9151
                    </Link>
                  </Col>
                </Row>
                <Row className={`${ContactStyle["text-reset"]}`}>
                  <Col className={`${ContactStyle["margin-bottom-8"]}`} span={24}>
                    <Text className={`${ContactStyle["contact-sub-title"]}`}>Roadside Assistance 24/7</Text>
                  </Col>
                  <Col
                    className={`${ContactStyle["margin-bottom-12"]}`}
                    lg={{ span: 24 }}
                    md={{ span: 0 }}
                    sm={{ span: 0 }}
                    xl={{ span: 24 }}
                    xs={{ span: 0 }}
                  >
                    <Text>866-522-1991</Text>
                  </Col>
                  <Col
                    className={`${ContactStyle["margin-bottom-12"]} ${ContactStyle["margin-top-4"]}`}
                    lg={{ span: 0 }}
                    md={{ span: 24 }}
                    sm={{ span: 24 }}
                    xl={{ span: 0 }}
                    xs={{ span: 24 }}
                  >
                    <Link className={`${ContactStyle["mobile-text"]}`} href="tel:+18665221991">
                      866-522-1991
                    </Link>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Divider className={`${ContactStyle["mobile"]}`} />
            <Col lg={{ span: 8 }} md={8} xl={7}>
              <Card bordered={false} className={`${ContactStyle["customer-relations-card"]}`}>
                <Row className={`${ContactStyle["text-reset"]}`}>
                  <Col className={`${ContactStyle["margin-bottom-8"]}`} span={24}>
                    <Text className={`${ContactStyle["contact-sub-title"]}`}>Headquarters</Text>
                  </Col>
                  <Col className={`${ContactStyle["margin-top-8"]}`} span={24}>
                    <Text className={`${ContactStyle["mobile-sub-text"]}`}>CURE Auto Insurance</Text>
                  </Col>
                  <Col span={24}>
                    <Text className={`${ContactStyle["mobile-sub-text"]}`}>214 Carnegie Center, Suite 301</Text>
                  </Col>
                  <Col span={24}>
                    <Text className={`${ContactStyle["mobile-sub-text"]}`}>Princeton, NJ 08540</Text>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}

Contact.propTypes = {}

export default Contact
